import { signupResultLayoutStyles } from '../SignupResultLayout/SignupResultLayout.styles';

export const signupErrorStyles = {
  resultMessage: signupResultLayoutStyles.resultMessage,
  resultActions: signupResultLayoutStyles.resultActions,
};
